import service from '@/utils/request'
import axios from '@/utils/axios-v2'




// /fleet/dispatch/v2/load/check/route/exist?loadId=10123

export function isRouteInfo(id) {
    return service({
        url: `/fleet/load/V3/check/route/exist?loadId=${id}`,
        method: "GET",
        headers: {
            'portal-token': true
        },
    })
}

// {
//     "id": 0,
//     "loadId": 0,
//     "routes": "string",
//     "settings": "string",
//     "truckInfo": "string",
//     "wayPoints": "string"
//   }

export function routeAddApi(data) {
    return axios({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: `/zuul/load/V3/route/add`,
        method: "POST",
        data: data,
        headers: {
            'portal-token': true,
            "Content-Type": "application/json",
        },
    })
}

export function shareV3RrouteApi(data) {
    return axios({
        url: `/fleet/load/trip/set/trip/from/load?edit=${false}`,
        method: "POST",
        data: data,
        headers: {
            'portal-token': true,
            "Content-Type": "application/json",
        },
    })
}

export function setJsonAppImParmas(id, data) {
    return axios({
        url: `/fleet/load/trip/set/load/json?loadId=${id}`,
        method: "POST",
        data: data,
        headers: {
            'portal-token': true,
            "Content-Type": "application/json",
        },
    })
}


export function routeAdd(data) {
    return service({
        url: `/fleet/route/add`,
        method: "POST",
        data: data,
        headers: {
            'portal-token': true
        },
    })
}

export function routeGet(id) {
    return service({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: `/zuul/route/info?loadId=${id}`,
        method: "GET",
        headers: {
            'portal-token': true
        },
    })
}

export function shartRoute(id, data) {
    return service({
        baseURL: process.env.VUE_APP_COMMAND_CENTER,
        url: `/zuul/load/V3/route/info/share?taskId=${id}`,
        method: 'put',
        data: data,
        headers: {
          'portal-token': true
        }
    })
}
// export function loadAssignRoute(loadsId,data) {
//     let city = [loadsId.loadInfo.deliveryAddress,loadsId.loadInfo.pickupAddress]
//     return service({
//       url: `/fleet/route/info/share?taskId=${loadsId.id}`,
//       method: 'put',
//       data: {
//         truckModel: {},
//         sendToUserId: 0,
//         routingMode: 'truck',
//         routingOption: {
//           difficultTurns: true,
//           dirtRoad: true,
//           toll:false,
//           tunnel:false
//         },
//         shape: data.shape,
//         waypoint: data.waypoint.map((item,index) => {
//           return {
//             mappedPosition: item.mappedPosition,
//             originalPosition: item.originalPosition,
//             shapeIndex: item.shapeIndex,
//             mappedRoadName: city[index],
//             timezone: 'EST'
//           }
//         }),
//         leg: data.sections.map(sections => {
//           return {maneuver : sections.actions._json.map(x => {
//               return {position: x.position}
//             })}
//         })
//       },
      
//       headers: {
//         'portal-token': true
//       }
//     })
//   } 